import Card from '@mui/material/Card';
import { CardProps } from '@mui/material/Card/Card';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { CARD_HEIGHT } from './Card';
import { Box } from '@mui/material';

const PreloaderCard = ({ sx }: CardProps) => {
  return (
    <Card
      sx={{
        minWidth: 200,
        width: '100%',
        ...sx,
        pb: 1,
      }}>
      <Stack
        spacing={1}
        sx={{
          height: CARD_HEIGHT,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          paddingLeft: 2,
        }}>
        <Skeleton variant="circular" width={40} height={40} />
        <Box sx={{ pl: 1}}>
          <Skeleton variant="rectangular" width={180} height={30}  />
          <Skeleton variant="rectangular" width={50} height={40} sx={{ mt: 1 }}/>
        </Box>
      </Stack>
    </Card>
  );
};

export default PreloaderCard;
